import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it safe for client confidentiality?',
  a: 'Yes, our guide includes a "Privacy First" protocol to ensure no sensitive PII is ever compromised.'
}, {
  q: 'Do I need to be a tech expert?',
  a: 'Not at all. If you can copy and paste, you can revolutionize your practice.'
}, {
  q: 'Is it a one-time payment?',
  a: 'Yes. Pay once, own the system and all future updates forever.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-41" data-mp="203jb5odf1de0">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-42" data-mp="1v5841lei9gzh">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-43" data-mp="oonlz8h57tj7">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-44" data-mp="jo9g9x30kvoc">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-45" data-mp="1plia8axpb263" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-46" data-mp="1pkqodrtwoit0">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-47" data-mp="11vxqhptq40vr">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-48" data-mp="16pa1uy9e6b6k" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-49" data-mp="rzudfoxc2hu1" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-50" data-mp="wxcobkuwv74o">
                  <div className="overflow-hidden" data-id="element-51" data-mp="j0qv4n5zq6gl">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-52" data-mp="myoidkg7aihc">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}